import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "utils/api";
import { CircularProgress } from "@mui/material";
import { getAllCyclesForTutor } from "services/financeService";

import ArgonBox from "components/ArgonBox";
import Table from "examples/Tables/Table";

import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";
import Attendance from "Views/Activities/ClassMgt/classSummary/attendance";
import CreditMapping from "Views/Activities/ClassMgt/classSummary/creditMapping";
import Payroll from "Views/Activities/ClassMgt/classSummary/payroll";
import Summary from "Views/Activities/ClassMgt/classSummary/summary";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import AttendanceListView from "Views/Activities/AllAttendance/AttendanceListView";

function AddTutor() {
  const { id } = useParams();
  const [classData, setClassData] = useState(null);
  const [payrollData, setPayrollData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchClassData();
    }
  }, [id]);

  const fetchClassData = async () => {
    try {
      setLoading(true);

      const classResponse = await axios.get(`/classes/session/${id}`);

      if (classResponse.data.success) {
        const sessionData = classResponse.data.data;

        const invoiceResponse = await axios.get(`/finance/get-all-raise-invoice`, {
          params: { page: 1, limit: 1000 },
        });

        const matchedInvoice = invoiceResponse?.data?.data?.find((item) => {
          const itemClassSessionId =
            item?.classSessionId?.[0]?._id || item?.classSessionDoc?._id || item?.classSessionId;

          return String(itemClassSessionId) === String(id);
        });

        const mergedClassData = {
          ...sessionData,
          invoices: matchedInvoice?.invoices || [],
          financeStatus: matchedInvoice?.status,
          paidAmount: matchedInvoice?.paidAmount || 0,
          pendingAmount: matchedInvoice?.pendingAmount || 0,
          totalInvoiceAmount: matchedInvoice?.totalAmount || 0,
        };

        setClassData(mergedClassData);

        console.log("Class Data:", sessionData);
        console.log("Matched Invoice:", matchedInvoice);
        console.log("Merged Class Data:", mergedClassData);

        if (sessionData?.tutor?._id) {
          await fetchTutorPayrollCycles(sessionData.tutor._id, id);
        }
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTutorPayrollCycles = async (tutorId, classSessionId) => {
    try {
      const response = await getAllCyclesForTutor(tutorId);
      console.log("All Tutor Cycles:", response.data);
      console.log("Looking for classSessionId:", classSessionId);
      if (response.success && response.data) {
        // Filter cycles that match the current class session ID
        const validCycles = response.data.filter((cycle) => {
          if (cycle.financeId === null) return false;
          // Match by classSessionId inside financeId
          const cycleClassSessionId =
            cycle.financeId?.classSessionId?._id || cycle.financeId?.classSessionId;
          const match = cycleClassSessionId === classSessionId;
          console.log(
            `Cycle ${cycle.cycleNumber}: cycleClassSessionId=${cycleClassSessionId}, match=${match}`
          );
          return match;
        });
        console.log("Valid Cycles Found:", validCycles);
        setPayrollData(validCycles);
      }
    } catch (error) {
      console.error("Error fetching tutor payroll cycles:", error);
    }
  };

  const tabsData = [
    {
      label: "Summary",
      icon: classData ? <i className="ri-check-line"></i> : <i className="ri-close-line"></i>,
      status: classData ? "success" : "error",
      content: <Summary classData={classData} refreshClassData={fetchClassData} />,
    },
    {
      label: "Attendance",
      icon: classData ? <i className="ri-check-line"></i> : <i className="ri-close-line"></i>,
      status: classData ? "success" : "error",
      content: <Attendance classData={classData} refreshClassData={fetchClassData} />,
    },
    {
      label: "Credit Mapping",
      icon: classData ? <i className="ri-check-line"></i> : <i className="ri-close-line"></i>,
      status: classData ? "success" : "error",
      content: <CreditMapping classData={classData} />,
    },
    {
      label: "Payroll",
      icon:
        payrollData && payrollData.length > 0 ? (
          <i className="ri-check-line"></i>
        ) : (
          <i className="ri-close-line"></i>
        ),
      status: payrollData && payrollData.length > 0 ? "success" : "error",
      content: <Payroll classData={classData} payrollCycles={payrollData} />,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonTypography mb={2} variant="h6">
                Classes Summary
              </ArgonTypography>

              <ArgonBox>
                {loading ? (
                  <ArgonBox display="flex" justifyContent="center" alignItems="center" p={5}>
                    <CircularProgress color="primary" />
                  </ArgonBox>
                ) : classData ? (
                  <ApnaTabs tabsData={tabsData} />
                ) : (
                  <ArgonBox textAlign="center" p={5}>
                    <ArgonTypography variant="h6" color="error">
                      Class not found
                    </ArgonTypography>
                  </ArgonBox>
                )}
              </ArgonBox>
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>

      <Footer />
    </DashboardLayout>
  );
}

export default AddTutor;
